import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from './user.model';
import { AuthData } from './auth-data.model';
import { Observable, of, Subject } from 'rxjs/index';
import { Router } from '@angular/router';
import { StorageService } from '../storage/storage.service';
import { UIService } from '../shared/ui.service';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/internal/operators';
import { Permission } from '../access/access.service';

@Injectable({
  providedIn: 'root'
})


export class AuthService {
  authChange = new Subject<boolean>();
  private user: User;

  constructor(
    private ngZone: NgZone,
    private http: HttpClient,
    private router: Router,
    private storage: StorageService,
    private uiService: UIService
    ) {}

  hasAccessToProject(projectId, permissionId) {
    if (isNaN(projectId) || projectId === null) {
      return true;
    }
    for (const access of this.user.accesses) {
      const project = access.project;
      if (project.id === projectId) {
        const permissions = access.permissions;
        for(const permission of permissions) {
          if (permission.id === Permission.ADMIN) {
            return true;
          }
          if (permission.id === permissionId) {
            return true;

          }
        }
      }

    }
    return false;
  }

  registerUser(authdata: AuthData) {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = `{"email": "${authdata.email}", "password":"${authdata.password}"}`;
    const url = environment.APIEndpoint + 'client-admin/';
    return this.http.post(url, body, {
      headers: headers
    }).subscribe(data => {
      this.uiService.loadingStateChanged.next(false);
      console.log("register: " + data);
      this.user = {
        token: data['token'],
        name: data['name'],
        has_information: data['has_information'],
        has_valid_email: data['has_valid_email'],
        profile_is_set: data['profile_is_set'],
        accesses: []
      };
      this.storage.setIdentity(this.user);
      this.authSuccessfully();
    }, error => {

      this.uiService.loadingStateChanged.next(false);
    },
      () => {
        this.ngZone.run( () => {
           console.log('stream completed');
          this.uiService.loadingStateChanged.next(false);
          this.authSuccessfully();
        });

      });
  }

  loginNew(state) {
    //this.login(authdata);
    this.uiService.loadingStateChanged.next(state);
    /*this.user = {
      email: authdata.email,
      token: ''
    };
    this.authSuccessfully();*/

  }

  logout() {
    this.user = null;
    this.storage.setIdentity(this.user);
    this.storage.setPreferredProject(null);
    this.authChange.next(false);
    this.router.navigate(['/login']);
  }

  updateUser(user) {
    this.user = user;
    this.storage.setIdentity(this.user);
    this.authChange.next(true);
  }

  getUser(): User {
    return { ...this.user }; // return a different object instance not the same reference
  }

  isAuthAsync(): Observable<boolean> | boolean {
    if (this.user) {
      return true;
    } else {
      const identity = this.storage.getIdentity();
      if (identity != null) {
        return this.validateToken(identity['token']);
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    }
  }

  validateToken(token): Observable<boolean> | boolean {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/token/';
    return this.http.post(url, body, {
          headers: headers
        }).pipe(
          map(result => {
            if (result['Error']) {
              alert("Movie not found at guard!");
              return false;
            } else {
              console.log("login: "+result );
              this.user = {
                token: result['token'],
                name: result['name'],
                has_information: result['has_information'],
                has_valid_email: result['has_valid_email'],
                accesses: result['accesses'],
                profile_is_set: result['profile_is_set']
              };
              console.log("login user: "+this.user );
              this.authSuccessfully();
              return true;
            }
            }),
            catchError((err) => {
              this.router.navigate(['/login']);
              return of(false);
            })
          );


    /*return this.http.post(url, body, {
      headers: headers
    }).subscribe(data => {
      console.log("login: "+data);
      this.user = {
        email: '',
        token: data['token']
      };
      this.authSuccessfully();
    });*/
  }

  validateEmail(email, password) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = `{"email": ${email}, "password":${password}}`;
    const url = environment.APIEndpoint + 'client-admin/';

    return this.http.post(url, body, {
      headers: headers
    });
  }

  login(authdata: AuthData) {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = `{"email": "${authdata.email}", "password":"${authdata.password}"}`;
    const url = environment.APIEndpoint + 'test-auth/';
    return this.http.post(url, body, {
      headers: headers
    }).subscribe(data => {
      this.uiService.loadingStateChanged.next(false);
      console.log("login: " + data);
      this.user = {
        token: data['token'],
        name: data['name'],
        has_information: data['has_information'],
        has_valid_email: data['has_valid_email'],
        accesses: data['accesses'],
        profile_is_set: data['profile_is_set']
      };
      this.storage.setIdentity(this.user);
      this.authSuccessfully();
    }, error => {

      this.uiService.loadingStateChanged.next(false);
      //this.authSuccessfully();
    },
      () => {
        this.ngZone.run( () => {
           console.log('stream completed');
          this.uiService.loadingStateChanged.next(false);
          this.authSuccessfully();
        });

      });
  }

  forgotPassword(authData) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = authData;
    const url = environment.APIEndpoint + 'client-api/profile/forgot-password/';

    return this.http.post(url, body, {
      headers: headers
    });
  }

  resetPassword(authData) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = authData;
    const url = environment.APIEndpoint + 'client-api/profile/reset-password/';

    return this.http.post(url, body, {
      headers: headers
    }).subscribe(data => {
      this.uiService.loadingStateChanged.next(false);
      console.log("resetPassword: " + data);
      this.user = {
        token: data['token'],
        name: data['name'],
        has_information: data['has_information'],
        has_valid_email: data['has_valid_email'],
        profile_is_set: data['profile_is_set'],
        accesses: []
      };
      this.storage.setIdentity(this.user);
      this.authSuccessfully();
    }, error => {
      this.uiService.loadingStateChanged.next(false);
    },
      () => {
        this.ngZone.run( () => {
           console.log('stream completed');
          this.uiService.loadingStateChanged.next(false);
          this.authSuccessfully();
        });
      });;
  }

  private authSuccessfully() {
    this.authChange.next(true);
    this.uiService.loadingStateChanged.next(false);
    this.router.navigate(['/dashboard']);
  }
}
